export interface PagingData {
    totalRecord: number;
    totalPage: number;
    pageSize: number;
    nowPage: number;
    pageGroup: number;
}

export interface PageSizeOption {
    value: number;
    label: string;
}

interface PaginationProps {
    paging: PagingData;
    onPageChange?: (page: number) => void;
}

const Pagination = ({ paging, onPageChange }: PaginationProps) => {
    // 페이지 번호 배열 생성
    const generatePageNumbers = (): number[] => {
        const { nowPage, totalPage, pageGroup } = paging;
        const start = Math.floor((nowPage - 1) / pageGroup) * pageGroup + 1;
        const end = Math.min(start + pageGroup - 1, totalPage);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const pageNumbers = generatePageNumbers();

    if (paging.totalPage <= 1) return null;

    return (
        <nav
            className="d-flex justify-content-center"
            aria-label="Page navigation example"
        >
            <ul className="pagination pagination-sm pagination-boxed pt-3">
                {/* 맨처음 버튼 */}
                <li
                    className={`page-item ${paging.nowPage <= 1 ? 'disabled' : ''}`}
                >
                    <a
                        className="page-link"
                        href="#"
                        aria-label="first Previous"
                        onClick={e => {
                            e.preventDefault();
                            if (paging.nowPage > 1) onPageChange?.(1);
                        }}
                        style={{
                            cursor: paging.nowPage <= 1 ? 'default' : 'pointer',
                        }}
                    >
                        <span aria-hidden="true">
                            <i className="ti ti-chevrons-left"></i>
                        </span>
                    </a>
                </li>

                {/* 이전 버튼 */}
                <li
                    className={`page-item ${paging.nowPage <= 1 ? 'disabled' : ''}`}
                >
                    <a
                        className="page-link"
                        href="#"
                        aria-label="Previous"
                        onClick={e => {
                            e.preventDefault();
                            if (paging.nowPage > 1)
                                onPageChange?.(paging.nowPage - 1);
                        }}
                        style={{
                            cursor: paging.nowPage <= 1 ? 'default' : 'pointer',
                        }}
                    >
                        <span aria-hidden="true">
                            <i className="ti ti-chevron-left"></i>
                        </span>
                    </a>
                </li>

                {/* 페이지 번호들 */}
                {pageNumbers.map(pageNum => (
                    <li
                        key={pageNum}
                        className={`page-item ${pageNum === paging.nowPage ? 'active' : ''}`}
                    >
                        <a
                            className="page-link"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                onPageChange?.(pageNum);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            {pageNum}
                        </a>
                    </li>
                ))}

                {/* 다음 버튼 */}
                <li
                    className={`page-item ${paging.nowPage >= paging.totalPage ? 'disabled' : ''}`}
                >
                    <a
                        className="page-link"
                        href="#"
                        aria-label="Next"
                        onClick={e => {
                            e.preventDefault();
                            if (paging.nowPage < paging.totalPage)
                                onPageChange?.(paging.nowPage + 1);
                        }}
                        style={{
                            cursor:
                                paging.nowPage >= paging.totalPage
                                    ? 'default'
                                    : 'pointer',
                        }}
                    >
                        <span aria-hidden="true">
                            <i className="ti ti-chevron-right"></i>
                        </span>
                    </a>
                </li>

                {/* 맨뒤 버튼 */}
                <li
                    className={`page-item ${paging.nowPage >= paging.totalPage ? 'disabled' : ''}`}
                >
                    <a
                        className="page-link"
                        href="#"
                        aria-label="Last"
                        onClick={e => {
                            e.preventDefault();
                            if (paging.nowPage < paging.totalPage)
                                onPageChange?.(paging.totalPage);
                        }}
                        style={{
                            cursor:
                                paging.nowPage >= paging.totalPage
                                    ? 'default'
                                    : 'pointer',
                        }}
                    >
                        <span aria-hidden="true">
                            <i className="ti ti-chevrons-right"></i>
                        </span>
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
